import { createContext } from "react"

import type { Span } from "types/spans.types"

export interface SpansContextValue {
  spansByTowerPair: Record<string, Span[]>
  isLoading: boolean
}

const SpansContext = createContext<SpansContextValue | null>(null)

export default SpansContext
